import React from "react"
import LabTabs from "../../components/header";

export const HomePage = () => {
  return (
    <LabTabs/>
  );
};
